import React, { useContext } from 'react';
import InputConfig from '../../../../Components/InputConfig';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import PageHeading from '../../../../Components/PageHeading';
//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';

//===============

const HbBidderTimeout = ({ keyData, featureDescription }) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Hb Bidder Timeout"
				headingPath={['Dashboard', 'Framerate', 'Network Data', 'Hb Bidder Timeout']}
				description="Manage Hb Bidder Timeout Configuration"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ marginLeft: '5rem', marginTop: '3rem', width: '90%' }}>
				<Grid item xs={3}>
					<InputConfig
						label="Hb Bidder Timeout (ms)"
						keyData={keyData}
						inputType="number"
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};
export default HbBidderTimeout;
